import 'src/styles/ui/info-row.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * InfoRow Component - Row layout for displaying label-value pairs
 * Typically used inside ResourceCardAlt body for structured information display
 *
 * @param {Object} props
 * @param {Object} props.icon - FontAwesome icon for the label (optional)
 * @param {string} props.label - Label text
 * @param {React.ReactNode} props.value - Value content (can be text, components, etc.)
 * @param {string} props.className - Additional CSS classes
 */
const InfoRow = ({ icon, label, value, className, ...props }) => {
  const rowClasses = classNames('info-row', className);

  return (
    <div className={rowClasses} {...props}>
      <div className='info-row__label'>
        {icon && <FontAwesomeIcon icon={icon} className='info-row__icon' />}
        <span>{label}</span>
      </div>
      <div className='info-row__value'>{value}</div>
    </div>
  );
};

InfoRow.propTypes = {
  icon: PropTypes.object,
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
  className: PropTypes.string,
};

InfoRow.defaultProps = {
  icon: null,
  className: '',
};

export default InfoRow;
